/** Vue **/
import Vue from 'vue'
import {
    serverBus
} from '@/main'

/** Utilites **/
import {
    CPUtils
} from '@/scripts/Utils'
import Global from '@/scripts/Global'

/** Handlers **/
import TypingHandler from '@/Handler/TypingHandler'

/** Managers **/
import SessionManager from '@/Manager/Session.manager';
import KeyboardManager from '@/Manager/keyboard.manager';
import TextareaManager from '@/Manager/Textarea.manager';
import DOMManager from '@/Manager/DOM.manager';

/** Compnenets **/
import {
    Picker
} from 'emoji-mart-vue'
import CPEmoji from '@/scripts/CPEmoji'
import MentionFolder from '@/components/KeyboardLists/MentionFolder/MentionFolder.vue'
import MentionUsers from '@/components/KeyboardLists/MentionUsers/MentionUsers.vue'
import ChannelList from '@/components/KeyboardLists/ChannelList'
import MessagePreview from '@/components/MessageArea/MessagePreview/MessagePreview.vue'
import GiphySearch from '@/components/MessageArea/GiphySearch/GiphySearch.vue'

/** Utils **/
import MessageBuilder from '@/Builder/Message.builder';
import PostApi from '@/scripts/api/post.api';
import config from '@/scripts/config';
import VueSignals from '@/scripts/VueSignals';
import DragAndDropMention from '@/scripts/mixins/DragAndDropMention.js';

let inputBox = null
let chatPannel = null
let installPrompt = null

let elementResizeEvent = require('element-resize-event');

export default {
    name: 'MessageArea',
    data() {
        return {
            showEmoji: false,
            activeChannelDoc: SessionManager.getActiveChannel(),
            loggedInUserId: SessionManager.getLoggedInUserId(),
            arrUserTyping: [],
            channelFactory: SessionManager,
            showUploadMenu: false,
            fileMessageError: '',
            mainMessageArea: config.DEFAULT_MESSAGE_AREA_ID,
            modalInView: false,
            typeingTimestamp: 0,
            oldTypeingTimestamp: 0,
            installPWABtn: 'none',
            connectionLost: false,
            windowWidth: window.innerWidth,
            currentFocused: '',
            messagePreloaded: null,
            messagePreloadedTitle: null,
            editActive: false,
            showGifs: false
        }
    },
    components: {
        Picker,
        CPEmoji,
        MentionFolder,
        MentionUsers,
        ChannelList,
        MessagePreview,
        GiphySearch
    },
    mixins: [DragAndDropMention],
    mounted() {
        KeyboardManager.enableChatMode();
        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth
            Global.globalValue("windowResize", true)
        });
        // if (typeof this.preLoadedMessageId != 'undefined' && document.getElementById(this.preLoadedMessageId) != null) {
        //     document.getElementById(this.preLoadedMessageId).scrollIntoView()
        // }

        KeyboardManager.UnstylePaste()
        document.querySelector(".emoji-mart-search").addEventListener('click', function() {
            KeyboardManager.disableChatMode()
        })

        chatPannel = document.querySelector('.chat-pannel')
        serverBus.$on(VueSignals.LOGGED_IN_USER, (ch_id) => {
            this.loggedInUserId = SessionManager.getLoggedInUserId()
        })

        serverBus.$on(VueSignals.SHOW_MODAL, (showModal) => {
            this.modalInView = showModal
        })

        serverBus.$on(VueSignals.REMOVE_TEXTAREA_PLACEHOLDER, (status) => {
            if (inputBox.classList.contains('empty')) {
                inputBox.classList.remove('empty')
            }
        })

        serverBus.$on(VueSignals.ACTIVE_CHANNEL_CHANGED_SIGNAL, (channel) => {
            this.activeChannelDoc = SessionManager.getActiveChannel()
            if (!this.modalInView) {
                DOMManager.RebuildChatArea()
            }
            // DOMManager.RestartMessaging()
        })


        inputBox = document.querySelector("#" + this.mainMessageArea)
        /********************New typing Notify****************/
        //@TODO TAKE ANOTHE LOOK
        serverBus.$on(VueSignals.TYPING_ACTION_NOTIFICATION, (data) => {
            if (data.event == VueSignals.TYPING_ACTION_NOTIFICATION &&
                data.channel_id == this.activeChannelDoc.channel_id) {
                if (data.origin.user_id != this.loggedInUserId) {
                    let username = SessionManager.getUser(data.origin.user_id).username
                    if (this.arrUserTyping.indexOf(username) < 0) {
                        this.arrUserTyping.push(username)
                    }
                    TypingHandler.stopTyping(data);
                }
            }
        })

        /********************destroy typing Notify****************/
        serverBus.$on(VueSignals.STOP_SEND_TYPYING_SIGNAL, (data) => {
            let username = SessionManager.getUser(data.origin.user_id).username;
            this.arrUserTyping.splice(this.arrUserTyping.indexOf(username), 1)
        })


        /**
         * KeyBoardManager  listener Events
         */


        serverBus.$on(VueSignals.HIDE_EMOJI_LIST, (from) => {
            this.showEmoji = false
        })

        serverBus.$on(VueSignals.CLOSE_MESSAGE_AREA_LIST, (from) => {
            if (from != 'emoji') {
                this.showEmoji = false
            }
        })

        serverBus.$on(VueSignals.SEND_MESSAGE, (success) => {
            this.sendMessage()
        })

        serverBus.$on(VueSignals.EMPTY_FILE_MESSAGE_REASON_SUCCESS, (success) => {
            this.file_message_success = ''
        })

        serverBus.$on(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, (message) => {
            fileMessageError = message
            setTimeout(function() {
                Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
            }, 3000)
        })

        serverBus.$on(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, (success) => {
            fileMessageError = ''
        })

        serverBus.$on(VueSignals.UPLOAD_FILE, (files) => {
            this.upload(files, true)
        })

        serverBus.$on(VueSignals.HIDE_CONTEXT_MENU, (success) => {
            this.showUploadMenu = false
        })

        serverBus.$on(VueSignals.TOOGLE_TEXT_CARET, (activate) => {
            if (activate) {
                // Put the caret at the end of the text area
                TextareaManager.MoveCursorAfterAdd(null);
            } else {
                document.activeElement.blur();
            }
        })

        document.addEventListener('click', e => {
            this.currentFocused = document.activeElement.id;
        });

        document.querySelector("#" + this.mainMessageArea).addEventListener('focus', function() {
            let customFileDOM = document.querySelector(".custom-file")
            if (customFileDOM != null) {
                customFileDOM.classList += " message-input-focus"
                document.querySelector(".chat-area").classList += " message-input-focus"
            }
            this.currentFocused = this.mainMessageArea;
        })

        document.querySelector("#" + this.mainMessageArea).addEventListener('focusout', function() {
            let fileupload = document.querySelector(".custom-file")
            if (fileupload != null && fileupload.classList.contains('message-input-focus')) {
                fileupload.classList.remove('message-input-focus')
            }

            let chatArea = document.querySelector(".chat-area")
            if (chatArea.classList.contains('message-input-focus')) {
                chatArea.classList.remove('message-input-focus')
            }
            this.currentFocused = '';
        })

        document.addEventListener('focusout', e => {
            var vm = this;
            setTimeout(() => {
                if (document.activeElement.id == '') {
                    vm.currentFocused = '';
                }
            }, 1);
        });

        window.addEventListener("beforeinstallprompt", e => {
            if (window.innerWidth < 681) {
                e.preventDefault()
                installPrompt = e
                this.installPWABtn = "block"
            }
        })

        if (['iPhone', 'iPad'].includes(navigator.platform)) {
            this.installPWABtn = "block"
        }

        serverBus.$on(VueSignals.CONNECTION_LOST, (status) => {
            this.connectionLost = status
        });

        serverBus.$on(VueSignals.SET_UP_EDIT_MESSAGE, (message) => {
            this.messagePreloaded = message;
            this.messagePreloadedTitle = this.$t('Edit message');
            this.buildInputAreaWithMessage(message);
            this.editActive = true;
        });

        // When message form changes size, calculate the size of chat queue (where messages are displayed)
        elementResizeEvent(document.getElementById('message_form'), () => {
          let formHeight = document.getElementById('message_form').offsetHeight;
          let channelInfoHeight = document.getElementsByClassName('channel-info')[0].offsetHeight;
          let chat_queue = document.getElementById('chat_queue');
          chat_queue.style.height = `calc(100vh - ${formHeight + channelInfoHeight}px)`;

          // Scroll to bottom
          chat_queue.scrollTop = chat_queue.scrollHeight;
        });

    },
    methods: {
        buildInputAreaWithMessage(message) {
            DOMManager.clearMessageArea();
            DOMManager.RestartCursor();
            DOMManager.RebuildChatArea();
            let items = MessageBuilder.decode(message);
            items.forEach((item, i) => {
                let element = null;
                switch (item.type) {
                    case 'text':
                        element = document.createElement("span");
                        element.style['white-space'] = 'pre-line';
                        let stylingItems = this.applyStyling(item.text);
                        for (let i = 0; i < stylingItems.length; i++) {
                            if (stylingItems[i].style == 'bold') {
                                element.innerHTML += `*${stylingItems[i].text}*`;
                            } else if (stylingItems[i].style == 'italic') {
                                element.innerHTML += `_${stylingItems[i].text}_`;
                            } else if (stylingItems[i].style == 'strike') {
                                element.innerHTML += `~${stylingItems[i].text}~`;
                            } else if (stylingItems[i].style == 'lbreak') {
                                element.appendChild(document.createElement("br"));
                            } else {
                                element.innerHTML += stylingItems[i].text;
                            }
                        }
                        break;
                    case 'file':
                        element = document.createElement("span");
                        element.classList = 'mention_slag';
                        element.dataset.id = Global.SaltID(5);
                        element.dataset.mention = item.file_id;
                        element.dataset.type = item.type;
                        element.innerHTML = item.text;
                        break;
                    case 'folder':
                        element = document.createElement("span");
                        element.classList = 'mention_slag';
                        element.dataset.id = Global.SaltID(5);
                        element.dataset.mention = item.file_id;
                        element.dataset.type = item.type;
                        element.innerHTML = item.text;
                        break;
                    case 'user':
                        element = document.createElement("span");
                        element.classList = 'mention_slag';
                        element.dataset.id = item.user_id;
                        element.innerHTML = item.text;
                        break;
                    case 'emoji':
                        element = document.createElement("img");
                        element.classList = 'emoji-icon';
                        element.dataset.id = Global.SaltID(5);
                        element.dataset.type = item.type;
                        let imgEmoji = CPUtils.getEmojiIMG(item.emoji_name);
                        element.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                        element.alt = imgEmoji.alt;
                        element.style = imgEmoji.style;
                        break;
                    default:
                        break;

                }
                if (element) {
                    if (inputBox.classList.contains('empty')) {
                        inputBox.classList.remove('empty')
                    }
                    TextareaManager.AddToCursor(element);
                }
            });
        },
        fireSendMessage(event) {
            // event.preventDefault();
            // event.stopPropagation();
            this.sendMessage();
        },
        sendMessage() {
            if (((!KeyboardManager.isNewLineActive() &&
                    (this.windowWidth <= 680 || !KeyboardManager.isListOpen())) || this.editActive) &&
                !this.connectionLost) {
                let dataToEncode = inputBox.childNodes[0]
                if (typeof dataToEncode.childNodes[dataToEncode.childNodes.length - 1] != 'undefined' &&
                    dataToEncode.childNodes[dataToEncode.childNodes.length - 1].nodeName == "BR") {

                    dataToEncode.removeChild(dataToEncode.childNodes[dataToEncode.childNodes.length - 1])
                }
                let oEncodedMessage = MessageBuilder.encode(dataToEncode)
                if (oEncodedMessage != null) {
                    if (this.editActive) { // case message editing
                        oEncodedMessage.edited = Math.floor(new Date().getTime() / 1000);
                        SessionManager.EditPost(this.messagePreloaded.post_id, oEncodedMessage.origin, oEncodedMessage.files);
                        this.closeMessagePreview(true);
                    } else { // case normal message
                        if (this.activeChannelDoc.channel_id == 'direct_message' ||
                            this.activeChannelDoc.channel_id == VueSignals.DRAFT_CHANNEL_ID) {
                            PostApi.create(oEncodedMessage.origin, SessionManager.getActiveChannelId(), oEncodedMessage.files)
                            if (this.activeChannelDoc.type == 'draft') {
                                document.getElementById(VueSignals.DRAFT_CHANNEL_ID).outerHTML = ""
                            }
                        } else {
                            PostApi.create(oEncodedMessage.origin, SessionManager.getActiveChannelId(), oEncodedMessage.files).then(res => {
                                // console.log(res) // @TODO still sending
                            })
                        }


                        CPUtils.ScrollChatMessagesToEnd()
                        KeyboardManager.enableChatMode()
                        KeyboardManager.init()
                        DOMManager.clearMessageArea()
                        if (this.windowWidth < 900 && this.currentFocused === this.mainMessageArea) {
                            DOMManager.RestartCursor()
                            DOMManager.RebuildChatArea()
                            this.currentFocused = this.mainMessageArea;
                        }
                    }
                    inputBox = document.querySelector("#" + this.mainMessageArea)
                    KeyboardManager.setInputArea(this.mainMessageArea, false)
                }
            }

            if (((!KeyboardManager.isNewLineActive() && !KeyboardManager.isListOpen()) || this.editActive) && this.connectionLost) {
                Global.globalValue(VueSignals.SEND_OFFLINE_MESSAGE, true)
            }
            if (chatPannel.classList.contains('edit')) {
                chatPannel.classList.remove('edit')
            }
        },
        typing(e) {
            this.typeingTimestamp = new Date().getTime()
            if (this.oldTypeingTimestamp == 0) {
                this.oldTypeingTimestamp = new Date().getTime()
            }
            this.showEmoji = false
            if (e.key == "Enter" && !KeyboardManager.isListOpen() && window.innerWidth > 680) { // Mobile check
                if (!e.shiftKey) {
                    this.sendMessage()
                }
                if (e.key == "Enter" && !KeyboardManager.isListOpen() && window.innerWidth < 680) {
                    document.execCommand('insertHTML', false, '<br>');
                }
            }

            if (!this.editActive && (e.code == "Space" ||
                    e.key == "ArrowLeft" ||
                    e.key == "ArrowRight")) {
                Global.globalValue(VueSignals.KEYBOARD_CLOSE_MESSAGE_LIST, true)
            }

            if (this.oldTypeingTimestamp - this.typeingTimestamp > 4999) {
                this.oldTypeingTimestamp = this.typeingTimestamp
                Global.globalValue(VueSignals.TYPING_ACTION, true)
            }

            if (!this.editActive) {
                TypingHandler.Notify()
            }
        },
        callEmoji() {
            this.showEmoji = !this.showEmoji;
            Global.globalValue(VueSignals.CLOSE_MESSAGE_AREA_LIST, 'emoji')
        },
        addEmoji(e) {
            KeyboardManager.enableChatMode()
            const EmojiClass = Vue.extend(CPEmoji)
            const vm = new EmojiClass({
                propsData: {
                    emo: e.id,
                }
            }).$mount()
            let emojiHTML = vm.$el
            this.showEmoji = false
            let img = document.createElement("img")
            img.classList = 'emoji-icon'
            img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
            img.alt = e.id
            img.contentEditable = true
            img.style = "background-position: " + emojiHTML.firstChild.style.backgroundPosition
            img.dataset.id = Global.SaltID(5)
            if (inputBox.classList.contains('empty')) {
                inputBox.classList.remove('empty')
            }
            TextareaManager.AddToCursor(img);
        },
        addMentionChar() {
            if (inputBox.classList.contains('empty')) {
                inputBox.classList.remove('empty')
            }
            Global.globalValue(VueSignals.CREATE_MENTION_USER, true)
            TextareaManager.MoveCursorAfterAdd(document.createTextNode(""))
        },
        HandleEditMessage(message) {
            return MessageBuilder.decode(message)
        },
        getEmoji(emojiID) {
            return CPUtils.getEmojiIMG(emojiID)
        },
        upload(e, hasFile = false) {
            let files = null
            if (!hasFile) {
                files = e.target.files
            } else {
                files = e
            }

            if (files != null && files.length > 0) {
                this.showUploadMenu = false
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL, true)
                Global.globalValue(VueSignals.SHOW_SMALL_MODAL_TYPE, VueSignals.UPLOAD_FILE)
                Global.globalValue(VueSignals.SMALL_OVERLAY_DATA, {
                    'ff_name': SessionManager.getActiveChannel().channel_name,
                    'ff_id': SessionManager.getActiveChannel().channel_id,
                    'ff_type': 'file',
                    'files': files
                })
            }
        },
        addMentionFile() {
            this.showUploadMenu = false
            let text = document.createTextNode('$')

            if (inputBox.classList.contains('empty')) {
                inputBox.classList.remove('empty')
            }


            let cursor = DOMManager.getCursor()
            if ((inputBox.childNodes.length == 1 && inputBox.childNodes[0].childNodes.length == 0)) { // edge case whrn the input is empty
                TextareaManager.AddToCursor(text)
                Global.globalValue(VueSignals.CREATE_MENTION_FOLDER, true)
                DOMManager.setCursor(inputBox.childNodes[0].childNodes[0], 1)
            } else if (typeof cursor.startContainer.textContent[cursor.startOffset - 1] != 'undefined' &&
                cursor.startContainer.textContent[cursor.startOffset - 1].replace(/&nbsp;/g, '') != 'f') {
                TextareaManager.AddToCursor(text)
                Global.globalValue(VueSignals.CREATE_MENTION_FOLDER, true)
            } else {
                cursor.startContainer.textContent += '@'
            }
        },
        containsStyling(text) {
            return CPUtils.HasTextStyling(text)
        },
        applyStyling(text) {
            return CPUtils.GetMessageDecodeDisplay(text)
        },
        PWAInstaller() {
            if (installPrompt != null) {
                if (!['iPhone', 'iPad'].includes(navigator.platform)) {
                    installPrompt.prompt()
                    installPrompt.userChoice
                        .then((choiceResult) => {
                            if (choiceResult.outcome === 'accepted') {
                                console.log('User accepted the A2HS prompt');
                            } else {
                                console.log('User dismissed the A2HS prompt');
                            }
                        });
                } else {
                    Global.globalValue("showPWAIOS", true)
                }
            }
        },
        closeMessagePreview(response) {
            this.editActive = false;
            this.messagePreloaded = null;
            this.messagePreloadedTitle = null;
            DOMManager.clearMessageArea();
            DOMManager.RestartCursor();
            DOMManager.RebuildChatArea();
            // Global.globalValue(VueSignals.REMOVE_POST_EDIT, true);
        }
    }
}
